const initialState = {
  showDelayTrackerModal: false,
  readOnly: true,
  showDelayTrackerFilters: false,
  showLogPdf: false,
};

export default function delayTrackerUiReducer(
  state = initialState,
  action = {}
) {
  switch (action.type) {
    case 'DELAY_TRACKER_SET_SHOW_MODAL':
      return { ...state, showDelayTrackerModal: action.payload };
    case 'DELAY_TRACKER_SET_READONLY':
      return { ...state, readOnly: action.payload };
    case 'DELAY_TRACKER_SET_SHOW_FILTERS':
      return { ...state, showDelayTrackerFilters: action.payload };
    case 'DELAY_TRACKER_SET_SHOW_LOG_PDF':
      return { ...state, showLogPdf: action.payload };
    default:
      return state;
  }
}
